// extracted by mini-css-extract-plugin
export default {"organizerResult":"OrganizerResult-module__organizerResult___1o1S2"};